import { createPinia } from 'pinia';

const install = (app) => {
  const store = createPinia();

  app.use(store);
};

export default install;